var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('schema-form',{attrs:{"schema":_vm.schema,"schema-data":_vm.project},on:{"updateByField":_vm.updateProjectByField}})}
var staticRenderFns = []

export { render, staticRenderFns }